export const contactsData = {
    email: 'sanketjaiswal2912@gmail.com',
    phone: '+91 9637877686',
    address: 'Mumbai, Maharashtra India - 421501',

    sheetAPI: ''
}